import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-301a60c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { storeToRefs } from 'pinia';
import { useAnniversary } from '@/store';
import { computed, inject } from 'vue';
import { useInfo } from '@/store';
import { Status } from '@/types/enums';

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleItemFigure',
  props: {
    className: null,
    index: null,
    prizeImage: null,
    prizeName: null,
    status: null
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "c1694188": (_unref(prizeFrame).pc),
  "3b8a156b": (_unref(prizeFrame).mobile),
  "fd5bd5b4": (_unref(knife).pc),
  "a3e07356": (_unref(knife).mobile),
  "58f5889c": (_unref(leftLine).pc),
  "7db562bb": (_unref(rightLine).pc),
  "186e3d92": (_unref(upLine).mobile),
  "0398ab50": (_unref(downLine).mobile)
}))


const { chosenScheduleItem } = storeToRefs(useAnniversary());
const { isTooltipVisible, showTooltip } = inject('tooltip');
const { getImg } = useInfo();
const prizeFrame = computed(() => ({
  pc: `url(${getImg('anniversary_pc_prize_frame')})`,
  mobile: `url(${getImg('anniversary_mobile_prize_frame')})`,
}));
const knife = computed(() => ({
  pc: `url(${getImg('anniversary_pc_knife')})`,
  mobile: `url(${getImg('anniversary_mobile_knife')})`,
}));
const leftLine = computed(() => ({
  pc: `url(${getImg('anniversary_pc_left_line')})`,
}));
const rightLine = computed(() => ({
  pc: `url(${getImg('anniversary_pc_right_line')})`,
}));
const upLine = computed(() => ({
  mobile: `url(${getImg('anniversary_mobile_up_line')})`,
}));
const downLine = computed(() => ({
  mobile: `url(${getImg('anniversary_mobile_down_line')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['figure', __props.className])
  }, [
    _createElementVNode("img", {
      class: "prize",
      src: __props.prizeImage,
      alt: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(showTooltip)(true)))
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass([
        'tooltip',
        {
          'tooltip--visible': _unref(isTooltipVisible) && __props.index === _unref(chosenScheduleItem),
        },
      ])
    }, _toDisplayString(__props.prizeName), 3)
  ], 2))
}
}

})